import {get} from "./backend"

export function getStates(handleResponse){
    get(
        "catalogues/states/",
        {}
    ).then(response => {handleResponse(response.data)})
}